import { render } from "./CompaniesList.vue?vue&type=template&id=3458063c&scoped=true&ts=true"
import script from "./CompaniesList.vue?vue&type=script&lang=ts"
export * from "./CompaniesList.vue?vue&type=script&lang=ts"

import "./CompaniesList.vue?vue&type=style&index=0&id=3458063c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3458063c"]])

export default __exports__